var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_18992)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_18992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_18992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79844 16.1984H19.7984V5.99844H7.79844V16.1984ZM7.79844 17.9984C7.30344 17.9984 6.87969 17.8222 6.52719 17.4697C6.17469 17.1172 5.99844 16.6934 5.99844 16.1984V4.19844C5.99844 3.70344 6.17469 3.27969 6.52719 2.92719C6.87969 2.57469 7.30344 2.39844 7.79844 2.39844H19.7984C20.2934 2.39844 20.7172 2.57469 21.0697 2.92719C21.4222 3.27969 21.5984 3.70344 21.5984 4.19844V16.1984C21.5984 16.6934 21.4222 17.1172 21.0697 17.4697C20.7172 17.8222 20.2934 17.9984 19.7984 17.9984H7.79844ZM4.19844 21.5984C3.70344 21.5984 3.27969 21.4222 2.92719 21.0697C2.57469 20.7172 2.39844 20.2934 2.39844 19.7984V5.99844H4.19844V19.7984H17.9984V21.5984H4.19844Z",
    fill: "#3F25AE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_18992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIcon);
export default __webpack_public_path__ + "static/media/type-icon.1a14aab8400248654329eed5b2257063.svg";
export { ForwardRef as ReactComponent };